import type { IFrontendServiceContainer } from '@phi/frontend/service-container';

import './BottomBar.scss';
import { utility } from '@phi/components';
import type { State } from '../state';

import { defineComponent, h, PropType } from 'vue';

import ButtonDropdown, { Toggle } from './ButtonDropdown';

import HideVertices from './BottomBar/HideVertices';
import HideEdges from './BottomBar/HideEdges';
import IsolateFaces from './BottomBar/IsolateFaces';

import ViewX from './BottomBar/ViewX';
import ViewY from './BottomBar/ViewY';
import ViewZ from './BottomBar/ViewZ';
import ViewAll from './BottomBar/ViewAll';
import ViewFace from './BottomBar/ViewFace';
import { SaveRecallViewpoint } from '@features/save-viewpoint';

import ToggleAxes from './BottomBar/ToggleAxes';
import ToggleShadow from './BottomBar/ToggleShadow';
import ToggleGrid from './BottomBar/ToggleGrid';
import { ToggleClipping, ToggleClippingEdit } from '@features/clipping';
import ToggleLockedRotate from './BottomBar/ToggleLockedRotate';

import Lightbulb from './BottomBar/Lightbulb';
import Bug from './BottomBar/Bug';
import Helpme from './BottomBar/Helpme';

import ShowGridSize from './BottomBar/ShowGridSize';
import { ShowMovingCoordinates, ShowSelectedCoordinates } from '@features/indicate-vertices';
import {
    ToggleCurvatureCombsButton,
    ShowCurvatureCombsOptionsButton,
} from '@features/curvature-combs';

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        app: { required: true, type: Object as PropType<IFrontendServiceContainer> },
    },

    render() {
        return h('div', {
            class: ['bar', 'bottom', utility.pointer_yes],
        }, [
            h('div', {
                class: 'group',
                style: { marginRight: 'auto' },
            }, [
                h(Lightbulb, { state: this.state }),
                h(Bug, { state: this.state }),
                h(Helpme, {
                    loaded: this.state.loaded,
                    aside: this.state.aside,
                    is_demo: this.state.is_demo,
                    'onUpdate:aside': x => this.state.aside = x,
                }),
            ]),

            h('div', { class: 'group' }, [
                h(HideVertices, { state: this.state }),
                h(HideEdges, { state: this.state }),
                h(IsolateFaces, { state: this.state }),
            ]),

            h('div', { class: 'group' }, [
                h(ViewX, { state: this.state}),
                h(ViewY, { state: this.state}),
                h(ViewZ, { state: this.state}),
                h(ViewAll, { state: this.state}),
                h(ViewFace, { state: this.state }),
                h(ToggleLockedRotate, { state: this.state }),
                h(SaveRecallViewpoint, { state: this.state}),
            ]),

            h('div', {
                class: 'group',
                style: {
                    marginRight: 'auto',
                    paddingRight: '160px',
                },
            }, [
                h(ToggleAxes, { state: this.state }),
                h(ToggleShadow, { state: this.state }),
                h(ButtonDropdown, {
                    id: 'curvature-combs-group',
                    direction: 'up',
                    disabled: false,
                }, {
                    primary: () => h(ToggleCurvatureCombsButton),
                    dropdown: () => h(ShowCurvatureCombsOptionsButton),
                }),

                h(ButtonDropdown, {
                    id: 'toggle-grid-group',
                    direction: 'up',
                    disabled: false,
                }, {
                    primary: () => h(ToggleGrid, { state: this.state, subscriptions: this.app.subscriptions}),
                    dropdown: (f: Toggle) => h(ShowGridSize, {
                        state: this.state,
                        'onUpdate:disabled': f,
                        subscriptions: this.app.subscriptions,
                    }),
                }),
                h(ButtonDropdown, {
                    id: 'clipping-group',
                    direction: 'up',
                    disabled: false,
                }, {
                    primary: () => h(ToggleClipping, { state: this.state, subscriptions: this.app.subscriptions}),
                    dropdown: (f: Toggle) => h(ToggleClippingEdit, {
                        state: this.state,
                        'onUpdate:disabled': f,
                        subscriptions: this.app.subscriptions,
                    }),
                }),
                h(ButtonDropdown, {
                    id: 'coordinates-group',
                    direction: 'up',
                    disabled: false,
                }, {
                    primary: () => h(ShowMovingCoordinates, { state: this.state }),
                    dropdown: (f: Toggle) => h(ShowSelectedCoordinates, { state: this.state, 'onUpdate:disabled': f }),
                }),
            ]),
        ]);
    },
});
